
export const markAsReadGroupMessage=(messages) => {
    return {
      type:"MARK_AS_READ_GROUP_MESSAGE",
      messages,
      segmentName: "groupMessageCount",
    }
  }
